const DEV_API_HOST = 'dev-api.hotlistcasino.com';
const PROD_API_HOST = 'api.hotlistcasino.com';

export const getApiBaseUrl = () => {
  const stripTrailingSlashes = (url: string) => url.replace(/\/+$/, '');

  const publicUrlRaw = String(process.env.NEXT_PUBLIC_API_BASE_URL ?? '').trim();
  const publicUrl = publicUrlRaw ? stripTrailingSlashes(publicUrlRaw) : '';

  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;

    const isLocalHost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '0.0.0.0';

    const isIpLike =
      /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname) || hostname.includes(':');

    // On our domain (incl. mobile): always derive API URL, never use baked localhost.
    if (hostname.endsWith('hotlistcasino.com')) {
      const apiHost = hostname.startsWith('dev') ? DEV_API_HOST : PROD_API_HOST;
      return `${protocol}//${apiHost}`;
    }

    // Use explicit env only when not localhost (avoid mobile calling localhost).
    if (publicUrl && (isLocalHost || !publicUrl.includes('localhost'))) {
      return publicUrl;
    }

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:3003';
    }

    if (isIpLike || hostname.endsWith('.local') || hostname.endsWith('.lan')) {
      return `${protocol}//${hostname}:3003`;
    }

    if (hostname.startsWith('dev-www.')) {
      return `${protocol}//dev-api.${hostname.slice('dev-www.'.length)}`;
    }
    if (hostname.startsWith('www.')) {
      return `${protocol}//api.${hostname.slice('www.'.length)}`;
    }
    return `${protocol}//dev-api.${hostname}`;
  }

  // Server-side fallback (can be internal URL).
  const serverUrl = String(process.env.API_BASE_URL ?? '').trim();
  if (serverUrl) {
    return stripTrailingSlashes(serverUrl);
  }

  // Final fallback for SSR/local tooling.
  return 'http://localhost:3001';
};

export const getStrapiUrl = () => {
  const stripTrailingSlashes = (url: string) => url.replace(/\/+$/, '');
  const publicUrl = String(process.env.NEXT_PUBLIC_CMS_URL ?? process.env.NEXT_PUBLIC_STRAPI_URL ?? '').trim();
  if (publicUrl) {
    return stripTrailingSlashes(publicUrl);
  }
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    if (hostname.startsWith('dev-www.')) {
      return `${protocol}//dev-cms.${hostname.slice('dev-www.'.length)}`;
    }
    if (hostname.startsWith('www.')) {
      return `${protocol}//cms.${hostname.slice('www.'.length)}`;
    }
  }
  return 'http://localhost:1338';
};

export const getStrapiApiToken = () => {
  return process.env.STRAPI_API_TOKEN || process.env.NEXT_PUBLIC_STRAPI_API_TOKEN || '';
};

export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export function getStrapiAuthHeaders(): Record<string, string> {
  const token = getStrapiApiToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
